import { ICreatePointsGroupState } from './types';

export enum CREATE_POINTS_GROUP_STEPS {
  TITLE = 'TITLE',
  DEVICES = 'DEVICES',
  MASTER_VIDEO_STREAM = 'MASTER_VIDEO_STREAM',
}

export const createPointsGroupDefaultState: ICreatePointsGroupState = {
  title: '',
  devices: null,
  masterVideoStream: null,
  step: CREATE_POINTS_GROUP_STEPS.TITLE,
};
